import * as React from "react";
import { User } from "appz";

interface IUserRow {
    users: User[];
    editUser: (id: string) => void;
    rowStyle: string;
    tableDataStyle: string;
}

const UserRow = (props: IUserRow): React.ReactElement => {
    const { users, editUser, rowStyle, tableDataStyle } = props;

    return (
        <tbody>
            {users.map(({ id, userName, email, roles }) => (
                <tr
                    key={userName}
                    className={rowStyle}
                    onClick={() => editUser(id)}>
                    <td>{userName}</td>
                    <td className={tableDataStyle}>{email}</td>
                    <td>
                        {roles
                            .map((r) => r.name)
                            .reduce(
                                (acc: any, curr: any) => `${acc}, ${curr}`,
                                "",
                            )
                            .replace(/^\,+|\,+$/g, "")
                            .trim()}
                    </td>
                </tr>
            ))}
        </tbody>
    );
};

export { UserRow };
